export class Group {
    GroupId: number = 0;
    groupName: string = "";
    ZipCode: string = "";
    CountyName: string = "";
    CountyCode: string = "";
    SicCode: string = "";
    SicDescription: String = "";
    SicCodeDetail: string = "";
    SICCodeId: number = 0;
    EffectiveDate: string = "";
    State: string = "";
    StateCode: string = "";
    IsNewGroup: boolean = true;
    AgencyId: number = 0;
    AgencyName: String = "";
    IsMulticountyZip: boolean = false;


}
